import { EducationAdsCard } from '@/app_components/widgets/EducationAdsCard';
import { WidgetBuilder, type WidgetResponse } from '@/app_data/widgets/utils';

type Props = {
  widget: WidgetResponse;
};

export const WidgetRenderer = ({ widget }: Props) => {
  if (!widget.widgets) {
    return null;
  }

  const component = WidgetBuilder(widget.widgets.data);
  const meta = component.buildMeta().get;

  if (meta('templateSlug') === 'recommends.education-ads') {
    return (
      <div className='not-prose'>
        <EducationAdsCard data={component} />
      </div>
    );
  }
  return <div />;
};
